import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Comune } from '../models/comune';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class ComuneService extends ResourcefulService<Comune>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Comune);
    }
}
